'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n  @import url(\'https://s3.amazonaws.com/sally-dashboard-assets/fonts/fonts.css\');\n  @import url(\'https://fonts.googleapis.com/css?family=Pacifico\');\n\n  html, body {\n    width: 100%;\n    padding: 0px;\n    margin: 0px;\n    display: block;\n    overflow: visible;\n    font-family: ProximaNova;\n    font-size: 14px;\n    color: ', ';\n    -webkit-font-smoothing: antialiased;\n  }\n\n  * {\n    box-sizing: border-box;\n    font-family: ProximaNova;\n  }\n\n  a {\n    text-decoration: none;\n  }\n\n  button, button:active, button:focus {\n    outline: none;\n  }\n\n  .DayPicker, .DayPicker * {\n    outline: none;\n  }\n\n  .DayPicker .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover,\n  .DayPicker .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n    background: ', ';\n    user-select: none;\n    pointer-events: none;\n  }\n\n  .DayPicker .DayPicker-Day--today {\n    color: ', ';\n  }\n\n  .DayPicker:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {\n    background: ', ' !important;\n  }\n\n  .DayPicker .DayPicker-Day {\n    padding: 10px;\n    border-radius: 10px !important;\n  }\n\n  .WeekPicker .DayPicker-Day--hoverRange {\n    background-color: ', ' !important;\n    border-radius: 0px !important;\n  }\n\n  .WeekPicker .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover,\n  .WeekPicker .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n    border-radius: 0 !important;\n    color: ', ' !important;\n  }\n\n  .Workflow .slick-list {\n    overflow: visible;\n  }\n\n  .PdfDocument html,\n  .PdfDocument body {\n    width: 100%;\n    display: block;\n    margin: 0px;\n    padding: 0px;\n    box-sizing: content-box;\n  }\n\n  .PdfDocument .start {counter-reset: none !important;}\n'], ['\n  @import url(\'https://s3.amazonaws.com/sally-dashboard-assets/fonts/fonts.css\');\n  @import url(\'https://fonts.googleapis.com/css?family=Pacifico\');\n\n  html, body {\n    width: 100%;\n    padding: 0px;\n    margin: 0px;\n    display: block;\n    overflow: visible;\n    font-family: ProximaNova;\n    font-size: 14px;\n    color: ', ';\n    -webkit-font-smoothing: antialiased;\n  }\n\n  * {\n    box-sizing: border-box;\n    font-family: ProximaNova;\n  }\n\n  a {\n    text-decoration: none;\n  }\n\n  button, button:active, button:focus {\n    outline: none;\n  }\n\n  .DayPicker, .DayPicker * {\n    outline: none;\n  }\n\n  .DayPicker .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover,\n  .DayPicker .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n    background: ', ';\n    user-select: none;\n    pointer-events: none;\n  }\n\n  .DayPicker .DayPicker-Day--today {\n    color: ', ';\n  }\n\n  .DayPicker:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {\n    background: ', ' !important;\n  }\n\n  .DayPicker .DayPicker-Day {\n    padding: 10px;\n    border-radius: 10px !important;\n  }\n\n  .WeekPicker .DayPicker-Day--hoverRange {\n    background-color: ', ' !important;\n    border-radius: 0px !important;\n  }\n\n  .WeekPicker .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover,\n  .WeekPicker .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n    border-radius: 0 !important;\n    color: ', ' !important;\n  }\n\n  .Workflow .slick-list {\n    overflow: visible;\n  }\n\n  .PdfDocument html,\n  .PdfDocument body {\n    width: 100%;\n    display: block;\n    margin: 0px;\n    padding: 0px;\n    box-sizing: content-box;\n  }\n\n  .PdfDocument .start {counter-reset: none !important;}\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  padding: 0px;\n  margin: 0px;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  ', ';\n'], ['\n  width: 100%;\n  padding: 0px;\n  margin: 0px;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _colors = require('../../libs/colors');

var _assetsContainer = require('../../libs/assetsContainer');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Styles
// Colors
// Libs


(0, _styledComponents.injectGlobal)(_templateObject, _colors.black, _colors.red, _colors.red, _colors.grey, _colors.grey, _colors.white);

var Page = _styledComponents2.default.div(_templateObject2, (0, _polished.clearFix)());

var Container = function (_Component) {
  _inherits(Container, _Component);

  function Container() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Container);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Container.__proto__ || Object.getPrototypeOf(Container)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      mounted: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Container, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({
        mounted: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['children']);

      var mounted = this.state.mounted;
      return _react2.default.createElement(Page, props, mounted && children, _assetsContainer.ASSET_CONTAINERS.map(function (ID) {
        return _react2.default.createElement('div', {
          key: ID,
          id: ID
        });
      }));
    }
  }]);

  return Container;
}(_react.Component);

exports.default = Container;